import { Component, OnInit, Input, Inject } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-cart-view',
    templateUrl: './cart-view.shared.component.html',
    styleUrls: ['./cart-view.shared.component.scss']
})
export class CartViewComponent implements OnInit {
    @Input() public size: OLO.Components.BUTTON_SIZE = 'lg';
    @Input() public badgeSize: OLO.Components.BADGE_SIZE = 'sm';

    public isVisible$: Observable<boolean>;
    public quantity$: Observable<number>;
    public value$: Observable<number>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
        public cartService: Services.CartService,
    ) { }

    ngOnInit(): void {
        this.isVisible$ = this.controllers.cart.showViewCart$();
        this.quantity$ = this.controllers.cart.cartTotalQuantity$();
        this.value$ = this.controllers.cart.cartTotalValue$();
    }

    public handleClick($event: Event): Promise<boolean> {
        return new Promise(resolve => {
            setTimeout(() => {
                this.cartService.showPopup()
                    .then(() => resolve(true));
            }, 100);
        });
    }
}
